import analyticsService from "./services/analyticsService";
import graphqlMutationService from "./services/graphqlMutationService";
import configureStore from "./utilities/configureStore";

export default configureStore({
  analyticsService,
  graphqlMutationService
});
